import React, { useState, useEffect } from 'react'

import { useTranslation } from 'src/utils/i18n'
import { Pagination } from 'antd'
import { getNotificationsList } from 'src/@api/login'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

import { Table } from 'antd'

import NoData from 'src/components/NoData'
import ContentLoading from 'src/components/ContentLoading'

dayjs.extend(utc)

const conversionUtcDate = (date, type) => {
  if (type === 'local') {
    // 传入local则将UTC时间转换为本地时间
    return dayjs.utc(date).local().format('YYYY-MM-DD HH:mm:ss')
  } else if (type === 'UTC') {
    // 传入UTC则将时间转换为UTC时间
    return dayjs(date).utc().format()
  }
}

const NotificationList = () => {
  // 当前选择页数
  const [total, setTotal] = useState(0)
  const [notificationsList, setNotificationsList] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  const onChangePage = async (page, pageSize) => {
    // 翻页不盖整页 ContentLoading，避免已有列表被白屏挡住
    try {
      let response = await getNotificationsList({ page, pageSize })
      if (response.data != null) {
        setTotal(response.total)
        setNotificationsList(response.data)
      } else {
        setNotificationsList([])
      }
    } catch (error) {
      console.error('Notifications page load error:', error)
    }
  }

  useEffect(() => {
    let setList = async () => {
      setIsLoading(true)
      try {
        let response = await getNotificationsList({ page: 1, pageSize: 10 })
        if (response.data != null) {
          setTotal(response.total)
          setNotificationsList(response.data)
        } else {
          setNotificationsList([])
        }
      } finally {
        setIsLoading(false)
      }
    }
    setList()
  }, [])

  const columns = [
    {
      title: 'Time',
      render: (text, record, index) => <span>{conversionUtcDate(record.createdAt, 'local')}</span>,
      key: 'id',
      width: '166px'
    },
    {
      title: 'Information',
      render: (text, record, index) => <span>{record.content}</span>,
      key: 'id'
    }
  ]

  if (isLoading && notificationsList.length === 0) {
    return (
      <div className='relative bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] min-h-[calc(var(--vh2)*100-90px)] flex'>
        <ContentLoading />
      </div>
    )
  }

  return (
    <>
      {notificationsList.length > 0 ? (
        <div>
          <Table columns={columns} dataSource={notificationsList} pagination={false} />
          <div style={{ textAlign: 'right', marginTop: '30px' }}>
            <Pagination onChange={onChangePage} defaultCurrent={1} total={total} />
          </div>
        </div>
      ) : (
        <div style={{ fontSize: '30px', display: 'flex', justifyContent: 'center' }}>
          <NoData />
        </div>
      )}
    </>
  )
}

export default NotificationList
